import { SetStateAction } from "react";
import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";

export const resetPasswordModal = ({
  t,
  windowValues,
  setWindowValues,
  resetUserPassword,
  closeMsg,
}: stdObject) => {
  return {
    title: t("p.enterNewPassword"),
    label: "",
    inputs: [
      {
        label: t("p.password"),
        value: windowValues.pass1,
        type: "password",
        onChange: (o: { target: { value: SetStateAction<string> } }) =>
          setWindowValues({ ...windowValues, pass1: o.target.value }),
      },
      {
        label: t("p.repeat"),
        value: windowValues.pass2,
        type: "password",
        onChange: (o: { target: { value: SetStateAction<string> } }) =>
          setWindowValues({ ...windowValues, pass2: o.target.value }),
      },
    ],
    buttons: [
      {
        label: t("p.change"),
        onClick: resetUserPassword,
        color: colors.green,
      },
      {
        label: t("p.cancel"),
        onClick: () => {
          closeMsg();
          setWindowValues({});
        },
        color: colors.darkGrey,
      },
    ],
  };
};
